module.exports = __webpack_public_path__ + "img/Illustration2.ef6710eb.png";